'use client';
import { Typography } from '@curology/ui-components-web/react/Typography';
import clsx from 'clsx';
import Image from 'next/image';
import React from 'react';
import { type ItemValue, type QuestionCheckboxModel } from 'survey-core';

const CheckboxImageItem = ({
  question,
  item,
}: {
  question: QuestionCheckboxModel;
  item: ItemValue;
}) => {
  const handleOnChange = () => {
    question.clickItemHandler(item, !item.selected);
  };

  // SurveyJS always requires a value, so we use 'hidden' to indicate that the image should not be shown
  const hasImage = item.imageLink !== 'hidden';
  const isSelected = question.isItemSelected(item);

  return (
    <div key={item.value} className="cur-h-full cur-relative">
      <div
        className={clsx(
          'cur-absolute cur-z-[1] -cur-inset-[2px] cur-border-surface-brand cur-border-4 cur-rounded-lg cur-pointer-events-none cur-transition-opacity cur-opacity-0',
          isSelected ? 'cur-opacity-100' : '',
        )}
      />

      <input
        role="option"
        aria-selected={question.isItemSelected(item)}
        className="cur-peer cur-sr-only"
        id={question.getItemId(item)}
        type="checkbox"
        name={question.questionName}
        defaultChecked={question.isItemSelected(item)}
        value={item.value}
        onClick={handleOnChange}
        tabIndex={0}
      />

      <label
        htmlFor={question.getItemId(item)}
        className={clsx(
          'cur-block cur-h-full cur-relative cur-cursor-pointer cur-rounded-lg cur-overflow-hidden peer-focus-visible:cur-bg-surface-highlight cur-transition-colors',
          isSelected ? 'cur-bg-surface-highlight' : 'cur-bg-surface-neutral',
        )}
      >
        <div className={clsx('cur-h-full')}>
          {hasImage && (
            <Image
              className={clsx('cur-aspect-[1.46] cur-w-full cur-object-cover')}
              alt={item.description}
              src={item.imageLink}
              width={106}
              height={73}
            />
          )}

          {(item.description || item.text) && (
            <div className="cur-p-[6px]">
              {item.text && (
                <Typography size="meta" weight="bold">
                  {item.text}
                </Typography>
              )}

              {item.description && (
                <Typography size="meta">{item.description}</Typography>
              )}
            </div>
          )}
        </div>
      </label>
    </div>
  );
};

export default CheckboxImageItem;
